import React, { useState, useEffect } from "react";
import "./lead_form.scss";

// Define the structure of a single query item
interface LeadQuery {
  _id: string;
  fullName: string;
  age: string;
  goal: string;
  phoneNumber: string;
  gender: string;
  height: string;
  weight: string;
  city: string;
  state: string;
  healthIssue: string;
  takingAnyMedicine: string;
  preferredWayToConnect: string;
  budget: string;
  createdAt: string;
}

const App = () => {
  return <LeadForm />;
};

const LeadForm = () => {
  const [queries, setQueries] = useState<LeadQuery[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Function to fetch the data from the API
    const fetchQueries = async () => {
      try {
        const response = await fetch("https://api.fitoja.in/api/get-lead-form");
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        // Assuming the data is an array of queries
        setQueries(data);
      } catch (err) {
        if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred");
        }
      } finally {
        setLoading(false); // Set loading to false once fetching is complete
      }
    };

    fetchQueries();
  }, []); // The empty dependency array ensures this runs only once on mount

  // Render different states based on loading and error
  if (loading) {
    return (
      <div className="lead-queries-container">
        <p className="loading">Loading queries...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="lead-queries-container">
        <p className="error">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="lead-queries-container">
      <h1>Meta Lead Form</h1>
      {queries.length > 0 ? (
        <div className="table-responsive">
          <table className="query-table">
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Phone Number</th>
                <th>Budget</th>
                <th>Age</th>
                <th>Goal</th>
                <th>Gender</th>
                <th>Height</th>
                <th>Weight</th>
                <th>City</th>
                <th>State</th>
                <th>Preferred way to connect</th>
                <th>Health Issue</th>
                <th>Taking any Medicine</th>
                <th>Date</th>
                {/* <th>Date Submitted</th> */}
              </tr>
            </thead>
            <tbody>
              {queries.map((query) => (
                <tr key={query._id}>
                  <td>{query.fullName}</td>
                  <td>{query.phoneNumber}</td>
                  <td>{query.budget}</td>
                  <td>{query.age}</td>
                  <td>{query.goal}</td>
                  <td>{query.gender}</td>
                  <td>{query.height}</td>
                  <td>{query.weight}</td>
                  <td>{query.city}</td>
                  <td>{query.state}</td>
                  <td>{query.preferredWayToConnect}</td>
                  <td>{query.healthIssue}</td>
                  <td>{query.takingAnyMedicine}</td>
                  <td>
                    {new Date(query.createdAt).toLocaleString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                    ,{" "}
                    {new Date(query.createdAt).toLocaleDateString("en-US", {
                      weekday: "short",
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="no-data">No queries found.</p>
      )}
    </div>
  );
};

export default App;
